import React from "react";
import { routesConfig } from "@src/core/routes";
import { Navigate, Route, Routes } from "react-router-dom";
import { ArcGlobalLoading } from "@src/core/widgets";
import { FlightProvider } from "@src/features/order/provider";

// Code-splitting: each feature chunk loads on demand to keep the initial bundle
// small and reduce the amount of retained JS on the heap while the tab is idle.
const OrderFeature = React.lazy(() => import("@src/features/order"));
const ChecklistFeature = React.lazy(() => import("@src/features/checklist"));
const ZonesFeature = React.lazy(() => import("@src/features/zones/feature"));
const HistoryFeature = React.lazy(() => import("@src/features/history"));
const DroneFeature = React.lazy(() => import("@src/features/drone"));
const FleetFeature = React.lazy(() => import("@src/features/fleet"));
const ViewerFeature = React.lazy(() => import("@src/features/viewer"));
const ProfileFeature = React.lazy(() => import("@src/features/profile"));
const SettingsFeature = React.lazy(() => import("@src/features/settings"));
const IntegrationFeature = React.lazy(() => import("@src/features/integration"));
const AnalyticsFeature = React.lazy(() => import("@src/features/analytics"));

const AdminRoutes: React.FC = () => {
  return (
    <FlightProvider>
      <React.Suspense fallback={<ArcGlobalLoading />}>
        <Routes>
          <Route path="/orders/*" element={<OrderFeature />} />
          <Route path="/checklist/*" element={<ChecklistFeature />} />
          <Route path="/zones/*" element={<ZonesFeature />} />
          <Route path="/history/*" element={<HistoryFeature />} />
          <Route path="/drones/*" element={<DroneFeature />} />
          <Route path="/fleet/*" element={<FleetFeature />} />
          <Route path="/viewer/*" element={<ViewerFeature />} />
          <Route path="/profile/*" element={<ProfileFeature />} />
          <Route path="/settings/*" element={<SettingsFeature />} />
          <Route path="/integration/*" element={<IntegrationFeature />} />
          <Route path="/analytics/*" element={<AnalyticsFeature />} />
          <Route path="*" element={<Navigate to={routesConfig.orders} />} />
        </Routes>
      </React.Suspense>
    </FlightProvider>
  );
};

export default AdminRoutes;
